import React, { useState } from 'react';

import { Button, Input, Select, Spin, Tag } from 'antd';
import ReactMarkdown from 'react-markdown';

import { bgPromptTestAPI } from '../api/bd-controller';
import { openNotification } from '../meta/globalToaster';

import './bg-page.css';

const { TextArea } = Input;

const BrandDiscoveryDevPage = () => {
  const [loading, setLoading] = useState(false);

  const [model, setModel] = useState('gpt-4o-mini');
  const [systemPrompt, setSystemPrompt] = useState('answer by considering you are in the USA.');
  const [mainPrompt, setMainPrompt] = useState('');
  const [response, setResponse] = useState('');

  const checkBDResult = () => {
    if (systemPrompt !== '' && mainPrompt !== '' && model != '') {
      setResponse('');
      setLoading(true);
      bgPromptTestAPI({
        model: model,
        systemPrompt: systemPrompt,
        mainPrompt: mainPrompt,
      }).then((data) => {
        try {
          if (data?.status) {
            if (data?.status === 200) {
              successSubmission(data?.message);
            } else {
              failSubmission('Please try again later!');
            }
          } else {
            failSubmission('Please try again later!');
          }
        } catch (error) {
          failSubmission('Please try again later!');
        }
      });
    } else {
      failSubmission('All input fields Required.');
    }
  };

  const successSubmission = (message: any) => {
    setLoading(false);

    // setSystemPrompt('');
    // setMainPrompt('');

    setResponse(message);
  };

  const failSubmission = (message: any) => {
    setLoading(false);
    openNotification({ message });
  };

  return (
    <div className="container p-3">
      <div className="row">
        <div className="col-sm-12">
          <h3>Brand Discovery Prompt Test</h3>
        </div>
      </div>

      <div className="row">
        <div className="col-sm-6">
          <div className="row">
            <div className="col-sm-12 mt-3 mb-3">
              <p className="a-input-label">Model</p>
              <Select
                showSearch
                value={model}
                style={{ width: '100%' }}
                placeholder="Select Model"
                onChange={(value) => {
                  setModel(value);
                }}
                options={[
                  {
                    value: 'gpt-4o-mini',
                    label: 'gpt-4o-mini',
                  },
                  {
                    value: 'gpt-4o-mini-2024-07-18',
                    label: 'gpt-4o-mini-2024-07-18',
                  },
                  {
                    value: 'gpt-4o-2024-05-13',
                    label: 'gpt-4o-2024-05-13',
                  },
                ]}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12 mt-3 mb-3">
              <p className="a-input-label">System Prompt</p>
              <TextArea
                value={systemPrompt}
                onChange={(e) => {
                  setSystemPrompt(e?.target?.value);
                }}
                placeholder="System Prompt"
                rows={3}
                // autoSize={{ minRows: 3, maxRows: 5 }}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12 mt-3 mb-3">
              <p className="a-input-label">Main Prompt</p>
              <TextArea
                value={mainPrompt}
                onChange={(e) => {
                  setMainPrompt(e?.target?.value);
                }}
                placeholder="Main Prompt"
                rows={15}
                // autoSize={{ minRows: 3, maxRows: 5 }}
              />
            </div>
          </div>

          <div className="row d-flex justify-content-end">
            <div className="col-sm-6 mt-3">
              <Button
                type="primary"
                size="large"
                style={{ width: '100%' }}
                onClick={() => {
                  checkBDResult();
                }}
                loading={loading}
              >
                Check Result
              </Button>
            </div>
          </div>
        </div>
        <div className="col-sm-6">
          <div className="row">
            <div className="row">
              <div className="col-sm-12">
                <h5>Result</h5>
              </div>
            </div>
            <div className="col-sm-12">
              {response != '' && (
                <div className="result-div">
                  <ReactMarkdown>{response}</ReactMarkdown>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandDiscoveryDevPage;
